(function(w, d, __tnt) {

    // ForEach polyfill
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    
    // Template.content polyfill
    var templateContent = function(template) {
        if ('content' in document.createElement('template')) {
            return template.content;
        } else {
            var fragment = document.createDocumentFragment();
            var children = template.childNodes;
            for (i = 0; i < children.length; i++) {
                fragment.appendChild(children[i].cloneNode(true));
            }
            return fragment;
        }
    };
    
    // Closest polyfill
    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
            var el = this;
            do {
                if (Element.prototype.matches.call(el, s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    // Helper function to handle negative modulo
    var mod = function(n, m) {
        return ((n % m) + m) % m;
    }

    // Debounce function
    var debounce = function(func, wait) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                func.apply(context, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };

    var eedition = __tnt.eedition || (__tnt.eedition = {});
    var ee = __tnt.eedition;
    
    /* Private vars */
    
    // Elements
    var container = d.getElementById('ee-container');
    var navbar = d.getElementById('ee-navbar');
    var zoomRange = d.getElementById('ee-zoom-range');
    var viewport = d.getElementById('ee-viewport');
    var pageview = d.getElementById('ee-pageview');
    var pageviewContent = d.getElementById('ee-pageview-content');
    var pageviewContWrapper = d.getElementById('ee-pageview-content-wrapper');
    var imagesWrapperProxy = d.getElementById('ee-images-wrapper-proxy');
    var imagesWrapper = d.getElementById('ee-images-wrapper');
    var imageContainerLeft = d.getElementById('ee-image-container-left');
    var imageLeft = d.getElementById('ee-image-left');
    var imageContainerRight = d.getElementById('ee-image-container-right');
    var imageRight = d.getElementById('ee-image-right');
    var storyview = d.getElementById('ee-storyview');
    var segment = d.getElementById('ee-segment');
    var storyviewContent = d.getElementById('ee-storyview-content');
    var storyviewTopAd = d.getElementById('ee-storyview-top-ad');
    var storyviewBottomAd = d.getElementById('ee-storyview-bottom-ad');
    var pageviewNextBtn = d.getElementById('ee-pageview-next-btn');
    var pagesMenu = d.getElementById('ee-pages-menu');
    var menu = d.getElementById('ee-menu');
    var printEditionBtn = d.getElementById('print-full-edition-btn');
    var pagepeekLeft = d.getElementById('ee-pagepeek-left');
    var pagepeekRight = d.getElementById('ee-pagepeek-right');
    var bottomAd = d.getElementById('ee-pageview-bottom-ad');
    var bottomAdCloseBtn = d.getElementById('ee-bottom-ad-close-btn');
    var overlayAdContainer = d.getElementById('ee-overlay-ad-container');
    var overlayAdRegion = (overlayAdContainer) ? overlayAdContainer.querySelector('.tncms-region') : null;
    var fitOneBtn = d.getElementById('ee-display-fit-1-btn');
    var fitTwoBtn = d.getElementById('ee-display-fit-2-btn');
    var navbarZoomSmall = d.querySelector('.ee-navbar-nav-zoom-sm');
    var navbarZoom = d.querySelector('.ee-navbar-nav-zoom');
    var navbarRegionPages = d.querySelector('.ee-navbar-region-pages');
    var navItemPuzzle = d.querySelector('.ee-nav-item-puzzles');
    var navItemEditions = d.querySelector('.ee-nav-item-editions');
    var menuBtnEditions = d.querySelector('.ee-menu-btn-editions');
    var navItemPrint = d.querySelector('.ee-nav-item-print');
    var menuBtnPrint = d.querySelector('.ee-menu-btn-print');
    var navItemDownload = d.querySelector('.ee-nav-item-download');
    var menuBtnDownload = d.querySelector('.ee-menu-btn-download');
    
    // State
    var pageNum = parseInt(container.dataset.pageNum);
    var pageviewOnRightEdge = false;
    var pageviewOnLeftEdge = false;
    var scrollbarWidth = 0;
    var navbarHeight = navbar.offsetHeight;
    var areAdsBlocked = false;
    var isStoryviewOpen = false;
    var isPagespaneOpen = false;
    var isMenuOpen = false;
    var isEditionsOpen = false;
    var isLoadingNewPage = false;
    var prevBottomAdHeight = bottomAd.offsetHeight;
    var overlayAdInterval = parseInt(container.dataset.overlayAdInterval);
    var overlayAdDisplayed = false;
    var overlayAdHasContent = (overlayAdRegion) ? overlayAdRegion.hasChildNodes() : false;
    var accessHelpCancel = false;
    var eventsRegistered = false;
    var localStorageSupported = __tnt.client.capabilities.supportsLocalStorage();
    
    // Facing pages
    var facingPagesOption = (container.dataset.facingPagesOption === 'true');
    var facingPagesDefault = (container.dataset.facingPagesDefault === 'true');
    var facingPagesUserPref = (localStorageSupported) ? localStorage.getItem('tnt-ee-facing-pages') : undefined;
    var facingPagesEnabled = null;
    var facingPagesActive = null;
    var pageDisplay = null; // left, right, both
    
    // Fit to (width/height)
    var fitTo = container.dataset.pageSizing;
    
    // Images
    var tallerImage = null;
    var imageLeftAspect = imageLeft.dataset.width / imageLeft.dataset.height;
    var imageLeftRealSize = [parseInt(imageLeft.dataset.width), parseInt(imageLeft.dataset.height)];
    
    var imageRightRealSize = [0, 0];
    if (imageRight) {
        var imageRightAspect = imageRight.dataset.width / imageRight.dataset.height;
        imageRightRealSize = [parseInt(imageRight.dataset.width), parseInt(imageRight.dataset.height)];
        tallerImage = (imageRightRealSize[1] >= imageLeftRealSize[1]) ? 'right' : 'left';
    }
    
    // Pageview
    var lastX = 0;
    var lastY = 0;
    var lastScale = 0.5;
    var SCALE = 0.5;
    var MIN_SCALE = 0.25;
    var MAX_SCALE = 2;

    var canPan = true;
    var isPanning = false;
    var panstartEl = null;
    
    var pinchCenter = null;
    var mouse = {x:0, y:0};
    
    var tap, press, pan, pinch;
    
    // Zoom
    var zoomMethod = null;
    
    /* Public vars */
    eedition.app = {

        _version: '2022',

        _init: function() {
            ee.utilities.detectIE();
            ee.utilities.detectMaxTouchPoints();
            ee.utilities.hideItemsNowapp();
            ee.utilities.hideFullscreenIos();
            
            ee.app.checkPageDisplay();
            ee.tracking.reportSegmented();
            
            scrollbarWidth = ee.utilities.getScrollbarWidth();

            ee.app.getScaleBounds();
            ee.pageview.initPageLayout();

            ee.pageview.asyncLoadImage(imageLeft);
            if (imageRight) {
                ee.pageview.asyncLoadImage(imageRight);
            }
            
            // HammerJS
            ee.hammer = new Hammer.Manager(pageviewContWrapper);
    
            tap = new Hammer.Tap();
            press = new Hammer.Press();
            pan = new Hammer.Pan({direction:Hammer.DIRECTION_ALL, threshold:10});
            pinch = new Hammer.Pinch({pointers:2, enable:true});
        
            pan.recognizeWith(pinch);
        
            ee.hammer.add(tap);
            ee.hammer.add(press);
            ee.hammer.add(pan);
            ee.hammer.add(pinch);
            
            ee.pageview.disableImgEventHandlers();
            ee.app.registerEvents();
            
            ee.pageview.scrollbarAdjust();
            
            ee.pagepeeks.check();
            
            // Ad-block detection
            if (typeof __tnt.advertisements == 'undefined') {
                areAdsBlocked = true;
            }

            ee.app.initAdObserver();
            ee.app.adHeightListener();
            
            // Check if we can show the ad
            if (localStorageSupported) {
                var adHiddenTimestamp = localStorage.getItem('tnt-ee-bottom-ad-hidden');
                // Check if it's been 24 hours
                if (!adHiddenTimestamp || adHiddenTimestamp < Date.now() - 86400000) {
                    bottomAd.classList.remove('ee-bottom-ad-hidden');
                    bottomAd.classList.add('ee-bottom-ad-shown');
                }
            }
            
            if (storyview) ee.storyview.init();
            
            // Subscription
            var hasTieredAccess = ee.subscription.tieredAccess();
            if (!hasTieredAccess && !viewport.classList.contains('subscriber-only') && !d.querySelector('.tnt-app-premium-content')) {
                // Check if we can show help screens
                if (localStorageSupported) {
                    var tutorialShown = localStorage.getItem('tnt-ee-tutorial-shown');
                    if (tutorialShown !== '1') {
                        ee.help.init();
                    }
                }
            }

            // Overlay Ad
            if (window.userStatus) {
                if (userStatus.hasAccess && !d.body.classList.contains('modal-open')) {
                    ee.app.displayOverlayAd();
                }
            } else {
                setTimeout(function() {
                    if (!d.body.classList.contains('modal-open') && !d.body.classList.contains('tp-modal-open')) {
                        ee.app.displayOverlayAd();
                    }
                }, 2500);
            }
        },
        
        initAdObserver: function() {
            if (bottomAd) {
                var observer = new MutationObserver(function(mutations, observer) {
                    var hasMutated = false;
                    for (var i = 0; i < mutations.length; i++) {
                        if (bottomAd.offsetHeight != prevBottomAdHeight) {
                            hasMutated = true;
                            prevBottomAdHeight = bottomAd.offsetHeight;
                        }
                    }
                    if (hasMutated) {
                        ee.pageview.adjustLayout();
                        // Hide close button if bottom ad has no height (didn't load or is blocked with ad blocker)
                        if (!bottomAd.querySelector('.tnt-ads') || (bottomAd.querySelector('.tnt-ads') && bottomAd.querySelector('.tnt-ads').offsetHeight == 0)) {
                            bottomAdCloseBtn.style.display = 'none';
                        } else {
                            bottomAdCloseBtn.style.display = '';
                        }
                    }
                });
                observer.observe(bottomAd, {attributes:true, attributeFilter:['style'], childList:true, subtree:true});
            }
        },
        
        /*
            This function's purpose is to check if the bottom ad height has changed in the first 
            ~2.5 seconds of page load. This is different than the mutation observer because ad 
            blockers inject/construct stylesheets which can change the ad height but won't trigger 
            the mutation observer.
        */
        adHeightListener: function() {
            var checks = 0;
            var checkAdHeight = function() {
                setTimeout(function() {
                    if (bottomAd.offsetHeight != prevBottomAdHeight) {
                        ee.pageview.adjustLayout();
                        prevBottomAdHeight = bottomAd.offsetHeight;
                        // Hide close button if bottom ad has no height (didn't load or is blocked with ad blocker)
                        if (!bottomAd.querySelector('.tnt-ads') || (bottomAd.querySelector('.tnt-ads') && bottomAd.querySelector('.tnt-ads').offsetHeight == 0)) {
                            bottomAdCloseBtn.style.display = 'none';
                        } else {
                            bottomAdCloseBtn.style.display = '';
                        }
                    }
                    checks++;
                    if (checks < 7) {
                        checkAdHeight();
                    }
                }, 333);
            };
            checkAdHeight();
        },

        displayOverlayAd: function() {
            if (localStorageSupported && overlayAdContainer && overlayAdHasContent && overlayAdInterval > 0 && !overlayAdDisplayed) {
                var overlayAdPagesViewed = localStorage.getItem('tnt-ee-overlay-ad-pages-viewed');
                overlayAdPagesViewed = (overlayAdPagesViewed !== null) ? parseInt(overlayAdPagesViewed) : 0;

                // Increment pages viewed
                overlayAdPagesViewed += 1;
                
                if (!areAdsBlocked && overlayAdPagesViewed >= overlayAdInterval) {
                    $('#ee-overlay-ad-modal').modal('show');
                    overlayAdContainer.hidden = false;
                    overlayAdDisplayed = true;
                    overlayAdPagesViewed = 0;
                }

                localStorage.setItem('tnt-ee-overlay-ad-pages-viewed', overlayAdPagesViewed);
            }
        },

        checkPageDisplay: function() {
            var facingPagesEnabledPrev = facingPagesEnabled;

            if (
                facingPagesOption
                && (facingPagesUserPref === 'true' || facingPagesDefault && facingPagesUserPref !== 'false')
                && window.innerWidth >= 768
            ) {
                pageDisplay = (imageRight) ? 'both' : 'left';
                facingPagesEnabled = true;
                facingPagesActive = (imageRight) ? true : false;
            } else {
                pageDisplay = (imageRight && pageNum % 2 == 1) ? 'right' : 'left';
                facingPagesEnabled = false;
                facingPagesActive = false;
            }

            if (facingPagesEnabled !== facingPagesEnabledPrev) {
                ee.app.facingPagesUpdate();
            }
        },
        
        facingPagesUpdate: function() {    
            // Legacy GTM Event
            if (window.dataLayer) {
                dataLayer.push({'tncms.eedition.display': (facingPagesActive) ? 'fit-two' : 'fit-one'});
            }
        
            // Set previous and next URLs
            d.querySelectorAll('.ee-navigation-prev-btn').forEach(function(el) {
                el.href = ee.app.getPrevUrl();
            });
            d.querySelectorAll('.ee-navigation-next-btn').forEach(function(el) {
                el.href = ee.app.getNextUrl();
            });
            
            pageview.dataset.pageDisplay = pageDisplay;
            
            // Hide storyview bottom bar if only 1 qualifying segment
            if (storyview) {
                var segments;
                if (pageDisplay == 'both') {
                    segments = d.querySelectorAll('.ee-story-templates template');
                } else {
                    segments = d.querySelectorAll('.ee-story-templates template[data-page="'+ pageDisplay +'"]');
                }
                if (segments.length == 1) {
                    storyview.classList.add('one-segment');
                } else {
                    storyview.classList.remove('one-segment');
                }
            }
            
            // Adds facing pages class
            if (facingPagesEnabled) {
                container.classList.add('ee-facing-pages-enabled');
            } else {
                container.classList.remove('ee-facing-pages-enabled');
            }
        },

        getPrevUrl: function() {
            return (facingPagesEnabled) ? __tnt.scrubUrl(container.dataset.facingPagesPrevUrl + location.search) : __tnt.scrubUrl(container.dataset.prevUrl + location.search);
        },

        getNextUrl: function() {
            return (facingPagesEnabled) ? __tnt.scrubUrl(container.dataset.facingPagesNextUrl + location.search) : __tnt.scrubUrl(container.dataset.nextUrl + location.search);
        },

        translate: function (deltaX, deltaY) {
            pageviewContent.scrollLeft = lastX + deltaX * -1;
            pageviewContent.scrollTop = lastY + deltaY * -1;
        },

        saveZoom: function() {
            if (localStorageSupported) {
                localStorage.setItem('tnt-ee-zoom-level', SCALE);
            }
        },

        zoom: function (_scale) {
            _scale = ee.utilities.clamp(_scale, MIN_SCALE, MAX_SCALE);
            ee.pageview.layoutPages(_scale);
            zoomRange.value = _scale;
            ee.app.saveZoom();
            ee.pageview.scrollbarAdjust();
            ee.pagepeeks.check();
            ee.advertising.renderBloxAds(pagepeekLeft);
            ee.advertising.renderBloxAds(pagepeekRight);
            
            ee.tracking.reportZoomDebounced(_scale);
        },
        
        zoomAround: function (_scale, zoomX, zoomY, relativeScale) {
            var imageCenterX = pageviewContent.scrollLeft + zoomX;
            var imageCenterY = pageviewContent.scrollTop + zoomY;
            
            var imageWidth = pageviewContent.scrollWidth;
            var imageHeight = pageviewContent.scrollHeight;
            
            var centerRatioX = imageCenterX / imageWidth;
            var centerRatioY = imageCenterY / imageHeight;
            
            if (relativeScale) {
                _scale *= SCALE;
            }
        
            ee.app.zoom(_scale);
            
            var newImageCenterX = imagesWrapper.offsetWidth * centerRatioX;
            var newImageCenterY = imagesWrapper.offsetHeight * centerRatioY;
            
            var deltaX = newImageCenterX - zoomX;
            var deltaY = newImageCenterY - zoomY;
            
            pageviewContent.scrollLeft = Math.round(deltaX);
            pageviewContent.scrollTop = Math.round(deltaY);
            
            lastX = pageviewContent.scrollLeft;
            lastY = pageviewContent.scrollTop;
        },
        
        zoomCenter: function(_scale) {
            // center of pageview content
            var zoomX = pageviewContent.clientWidth / 2;
            var zoomY = pageviewContent.clientHeight / 2;
            
            ee.app.zoomAround(_scale, zoomX, zoomY);
        },

        getScale: function() {
            if (!localStorageSupported || container.dataset.rememberZoom === 'false') {
                return ee.app.getDefaultScale();
            }

            var zoomLevel = parseFloat(localStorage.getItem('tnt-ee-zoom-level'));

            if (zoomLevel) {
                return ee.utilities.clamp(zoomLevel, MIN_SCALE, MAX_SCALE);
            }

            return ee.app.getDefaultScale();
        },

        // Get the width of the page(s) and get the width of the browser and determine what the scale should be
        getDefaultScale: function() {
            var imageSizes = ee.pageview.getImageSizes();
            
            if (container.dataset.pageSizing === 'width') {
                var pageviewWidth = pageviewContent.offsetWidth;
                var imagesWidth = imageSizes[0][0] + imageSizes[1][0];
                return pageviewWidth / imagesWidth;

            // Get the height of the tallest page and get the height of the page viewport and determine what the scale should be
            } else {
                var pageviewHeight = pageviewContent.offsetHeight;
                var imagesHeight = (imageSizes[0][1] >= imageSizes[1][1]) ? imageSizes[0][1] : imageSizes[1][1];
                return pageviewHeight / imagesHeight;
            }
        },

        getScaleBounds: function() {
            var imageSizes = ee.pageview.getImageSizes(),
                pageviewHeight = pageviewContent.offsetHeight,
                pageviewWidth = pageviewContent.offsetWidth,
                imagesWidth = imageSizes[0][0] + imageSizes[1][0],
                imagesHeight = (imageSizes[1][1] >= imageSizes[0][1]) ? imageSizes[1][1] : imageSizes[0][1],
                widthScale = pageviewWidth / imagesWidth,
                heightScale = pageviewHeight / imagesHeight;

            MIN_SCALE = (widthScale < heightScale) ? widthScale : heightScale;
            MIN_SCALE = parseFloat(MIN_SCALE.toFixed(12));
            // This adds 2 to MIN_SCALE and fixes floating point imprecision that prevented MAX_SCALE from being selected in the range input
            MAX_SCALE = (MIN_SCALE.toFixed(12) * 1E12 + 2E12) / 1E12;
            zoomRange.min = MIN_SCALE;
            zoomRange.max = MAX_SCALE;
        },

        setFocus: function() {
            if (isEditionsOpen) return;

            if (isStoryviewOpen) {
                storyviewContent.focus();

            } else if (isPagespaneOpen) {
                d.getElementById('ee-pages-menu-content').focus();

            } else if (isMenuOpen) {
                d.querySelector('#ee-menu .ee-menu-items').focus();

            } else {
                pageviewContent.focus();
            }
        },

        registerEvents: function() {
            if (eventsRegistered) return;

            var resizeEvent = function() {
                ee.app.checkPageDisplay();
            
                ee.pageview.adjustLayout();
                ee.pagepeeks.check(true);

                // Handle tour resizing
                if (ee.help && ee.help.tour && ee.help.tour.isActive()) {
                    ee.help.debounce();
                }

                clearTimeout(ee.pageview.scrollbarTimeout);
                ee.pageview.scrollbarTimeout = setTimeout(ee.pageview.scrollbarAdjust, 250);
            };

            window.addEventListener('resize', function(e) {
                if (ee.browser.isIosChrome()) {
                    setTimeout(resizeEvent, 100);
                } else {
                    resizeEvent();
                }
            });

            window.addEventListener('orientationchange', function(e) {
                d.documentElement.style.height = 'initial';
                if (ee.browser.isIosChrome()) {
                    setTimeout(resizeEvent, 200);
                }
            });

            // pinch-zoom with touchpad/ctrl+mousewheel
            container.addEventListener('wheel', function(e) {
                if (e.ctrlKey) {
                    e.preventDefault();

                    if (!document.body.classList.contains('modal-open')) {
                        var s;
                        // mousewheel
                        if (Math.abs(e.deltaY) > 25) {
                            s = e.deltaY * -0.002;
                            zoomMethod = 'scroll_wheel';
                            debouncedLogZoom();
                        // touchpad
                        } else {
                            s = e.deltaY * -0.02;
                            zoomMethod = 'pinch_zoom';
                            debouncedLogZoom();
                        }

                        if (isPagespaneOpen) {
                            ee.pagespane.close();
                        }
                        if (isMenuOpen) {
                            ee.menu.close();
                        }

                        SCALE = ee.utilities.clamp(SCALE + s, MIN_SCALE, MAX_SCALE);
                        ee.app.zoomCenter(SCALE, true);
                    }
                }
            });

            // Load next page hires image
            window.addEventListener('load', function() {
                var hiResUrl = container.dataset.nextImageUrl;
                if (hiResUrl) {
                    var hiResImage = new Image();
                    hiResImage.src = hiResUrl;
                }
            });

            d.addEventListener('pointerup', function(e) {
                if (d.activeElement.id === 'ee-zoom-range') {
                    zoomRange.blur();
                    pageviewContent.focus();
                    zoomMethod = 'navbar';
                    debouncedLogZoom();
                }
            });

            d.addEventListener('keydown', function(e) {
                // Prevent keyboard shortcuts when a modal is open
                if (d.body.classList.contains('modal-open')) {
                    return;
                }

                var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', '-', '='];
                if (keys.indexOf(e.key) !== -1) {
                    ee.app.setFocus();
                }
                
                if (!ee.clip.canvasEnabled && d.activeElement == pageviewContent || d.activeElement == storyviewContent) {
                    if (e.key == '-' && !e.ctrlKey) {
                        SCALE = ee.utilities.clamp(SCALE - 0.2, MIN_SCALE, MAX_SCALE);
                        zoomMethod = 'keyboard';
                        debouncedLogZoom();
                        ee.app.zoomCenter(SCALE, true);
                    } else if (e.key == '=' && !e.ctrlKey) {
                        SCALE = ee.utilities.clamp(SCALE + 0.2, MIN_SCALE, MAX_SCALE);
                        zoomMethod = 'keyboard';
                        debouncedLogZoom();
                        ee.app.zoomCenter(SCALE, true);
                    }
                }

                if (e.key == 'ArrowLeft') {
                    if (d.activeElement == pageviewContent) {
                        if (!ee.clip.canvasEnabled && !isLoadingNewPage && pageviewContent.scrollLeft == 0) {
                            // E-Edition Page Navigate Event
                            __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'keyboard'});
                            
                            location.href = ee.app.getPrevUrl();
                            isLoadingNewPage = true;
                        }
                    } else if (d.activeElement == storyviewContent) {
                        ee.storyview.loadPrevious();
                    }

                } else if (e.key == 'ArrowRight') {
                    if (d.activeElement == pageviewContent) {
                        if (!ee.clip.canvasEnabled && !isLoadingNewPage && imagesWrapper.clientWidth - pageviewContent.clientWidth <= Math.ceil(pageviewContent.scrollLeft)) {
                            // E-Edition Page Navigate Event
                            __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'keyboard'});
                            
                            location.href = ee.app.getNextUrl();
                            isLoadingNewPage = true;
                        }
                    } else if (d.activeElement == storyviewContent) {
                        ee.storyview.loadNext();
                    }
                }

                if (e.key == 'Escape') {
                    if (isMenuOpen) {
                        ee.menu.close();
                    } else if (isStoryviewOpen) {
                        ee.storyview.close();
                    } else if (isPagespaneOpen) {
                        ee.pagespane.close();
                    }
                }
            });

            d.addEventListener('click', function(e) {
                if (
                    e.target.classList.contains('shepherd-modal-overlay-container')
                    || (e.target.parentElement && e.target.parentElement.classList.contains('shepherd-modal-overlay-container'))
                ) {
                    ee.help.tour.cancel();
                    
                } else if (e.target.classList.contains('cutout-menu-btn')) {
                    ee.cutouts.toggleMenu(e.target.dataset.modalId);
                    
                } else if (e.target.classList.contains('textsize-btn')) {
                    var segment = d.getElementById('ee-segment').querySelector('article.segment');
                    $(e.target).popover({
                        html: true,
                        sanitize: false,
                        trigger: 'manual',
                        placement: 'left',
                        content: function() {
                            var activeSize;
                            if (localStorageSupported && localStorage.getItem('tnt-eedition-textsize')) {
                                activeSize = localStorage.getItem('tnt-eedition-textsize');
                            } else if (segment.classList.contains('text-md')) {
                                activeSize = 'md';
                            } else if (segment.classList.contains('text-lg')) {
                                activeSize = 'lg';
                            }

                            var popHtml = ''+
                                '<div id="eedition-text-size-popover">'+
                                    '<div class="eedition-popover-btns btn-group" data-toggle="buttons">'+
                                        '<button class="btn btn-default textsize-md'+ (!activeSize || activeSize == 'md' ? ' active' : '') +'" data-text-size="md">A</button>'+
                                        '<button class="btn btn-default textsize-lg'+ (activeSize == 'lg' ? ' active' : '') +'" data-text-size="lg">A</button>'+
                                    '</div>'+
                                '</div>';
                            return popHtml;
                        }
                    }).popover('toggle');
                    
                } else if (e.target.classList.contains('textsize-md') || e.target.classList.contains('textsize-lg')) {
                    var segment = d.getElementById('ee-segment').querySelector('article.segment');
                    segment.classList.remove('text-md', 'text-lg');
                    segment.classList.add('text-' + e.target.dataset.textSize);
                    if (localStorageSupported) {
                        localStorage.setItem('tnt-eedition-textsize', e.target.dataset.textSize);
                    }
                    $('.textsize-btn').popover('toggle');

                } else if (e.target.classList.contains('segment-social-print')) {
                    var printTemplate = d.getElementById(e.target.dataset.printAsset.replace('#',''));
                    if (printTemplate) {
                        e.preventDefault();
                        _print(printTemplate);
                    }
                // Video modal handling
                } else if (e.target.closest('.asset-content > .inline-video a, .asset-content > .inline-youtube a')) {
                    e.preventDefault();
                    var uuid = e.target.closest('.asset-content > .inline-video, .asset-content > .inline-youtube').dataset.uuid;
                    var videoModal = d.getElementById('modal-' + uuid);
                    $('#modal-' + uuid).modal('show');
                }
            });
            
            ee.help.tour.on('cancel', function() {
                if (!accessHelpCancel && localStorageSupported) {
                    localStorage.setItem('tnt-ee-tutorial-shown', '1');
                }
                ee.menu.close();
            });
            ee.help.tour.on('complete', function() {
                if (localStorageSupported) {
                    localStorage.setItem('tnt-ee-tutorial-shown', '1');
                }
                ee.menu.close();
            });

            // User status event logic
            w.addEventListener('tnt-user-status', function(e) {
                // if user doesn't have access or a modal is open
                if (e.hasAccess === false || d.body.classList.contains('modal-open')) {
                    // Cancel help tour if access control paywall displays
                    if (ee.help.tour.isActive()) {
                        accessHelpCancel = true;
                        ee.help.tour.cancel();
                    }
                } else {
                    ee.app.displayOverlayAd();
                }
            });
            
            // Zoom range
            zoomRange.addEventListener('input', function(e) {
                if (isPagespaneOpen) {
                    ee.pagespane.close();
                }
                if (isMenuOpen) {
                    ee.menu.close();
                }
                SCALE = parseFloat(e.target.value);
                ee.app.zoomCenter(SCALE);
            });
            
            navbar.querySelectorAll('.ee-zoom-out').forEach(function(el) {
                el.addEventListener('click', function(e) {
                    if (isPagespaneOpen) {
                        ee.pagespane.close();
                    }
                    if (isMenuOpen) {
                        ee.menu.close();
                    }
                    SCALE = ee.utilities.clamp(SCALE - 0.2, MIN_SCALE, MAX_SCALE);
                    zoomMethod = 'navbar';
                    debouncedLogZoom();
                    ee.app.zoomCenter(SCALE, true);
                });
            });
            
            navbar.querySelectorAll('.ee-zoom-in').forEach(function(el) {
                el.addEventListener('click', function(e) {
                    if (isPagespaneOpen) {
                        ee.pagespane.close();
                    }
                    if (isMenuOpen) {
                        ee.menu.close();
                    }
                    SCALE = ee.utilities.clamp(SCALE + 0.2, MIN_SCALE, MAX_SCALE);
                    zoomMethod = 'navbar';
                    debouncedLogZoom();
                    ee.app.zoomCenter(SCALE, true);
                });
            });

            // Toggle fullscreen
            d.getElementById('ee-display-fullscreen-btn').addEventListener('click', function() {
                // Standard Event
                __tnt.eedition.logEEditionDisplayFitSelected({
                    'selected_fit': fitTo,
                    'selected_num_of_pages': facingPagesEnabled? 2 : 1,
                    'is_fullscreen': document.fullscreenElement !== null ? false : true,
                    'is_cover': pageNum == 1 ? true : false
                });
                
                ee.pageview.toggleFullscreen();
            });
            
            // Fit to width
            d.getElementById('ee-display-width-btn').addEventListener('click', function() {
                fitTo = 'width';
                
                // Standard Event
                __tnt.eedition.logEEditionDisplayFitSelected({
                    'selected_fit': fitTo,
                    'selected_num_of_pages': facingPagesEnabled? 2 : 1,
                    'is_fullscreen': document.fullscreenElement !== null ? true : false,
                    'is_cover': pageNum == 1 ? true : false
                });

                ee.pageview.fitToWidth();
            });
            
            // Fit to height
            d.getElementById('ee-display-height-btn').addEventListener('click', function() {
                fitTo = 'height';
                
                // Standard Event
                __tnt.eedition.logEEditionDisplayFitSelected({
                    'selected_fit': fitTo,
                    'selected_num_of_pages': facingPagesEnabled? 2 : 1,
                    'is_fullscreen': document.fullscreenElement !== null ? true : false,
                    'is_cover': pageNum == 1 ? true : false
                });
                
                ee.pageview.fitToHeight();
            });
            
            // Fit One page
            if (fitOneBtn) {
                fitOneBtn.addEventListener('click', function() {
                    if (localStorageSupported) localStorage.setItem('tnt-ee-facing-pages', 'false');
                    facingPagesUserPref = 'false';
                    ee.app.checkPageDisplay();
                    ee.pageview.layoutPages();
                    ee.app.getScaleBounds();
                    ee.pageview.fit();
                    ee.pagepeeks.check();
                    
                    // Standard Event
                    __tnt.eedition.logEEditionDisplayFitSelected({
                        'selected_fit': fitTo,
                        'selected_num_of_pages': 1,
                        'is_fullscreen': document.fullscreenElement !== null ? true : false,
                        'is_cover': pageNum == 1 ? true : false
                    });
                    
                    // Legacy Event
                    ee.tracking.report({'event':'tncms.event.trigger','tncms':{'event':{'trigger':{'action':'display','category':'e-edition','label':'fit-one'}}}});
                    ee.tracking.reportSegmented();
                });
            }
            
            // Fit Two pages
            if (fitTwoBtn) {
                fitTwoBtn.addEventListener('click', function() {
                    if (localStorageSupported) localStorage.setItem('tnt-ee-facing-pages', 'true');
                    facingPagesUserPref = 'true';
                    ee.app.checkPageDisplay();
                    ee.pageview.layoutPages();
                    ee.app.getScaleBounds();
                    ee.pageview.fit();
                    ee.pagepeeks.check();
                    
                    // Standard Event
                    __tnt.eedition.logEEditionDisplayFitSelected({
                        'selected_fit': fitTo,
                        'selected_num_of_pages': 2,
                        'is_fullscreen': document.fullscreenElement !== null ? true : false,
                        'is_cover': pageNum == 1 ? true : false
                    });
                    
                    // Legacy Event
                    ee.tracking.report({'event':'tncms.event.trigger','tncms':{'event':{'trigger':{'action':'display','category':'e-edition','label':'fit-two'}}}});
                    ee.tracking.reportSegmented();
                });
            }
            
            $('.modal').on('show.bs.modal', function (e) {
                if (isPagespaneOpen) {
                    ee.pagespane.close();
                }
                if (isMenuOpen) {
                    ee.menu.close();
                }
                if (isStoryviewOpen) {
                    ee.storyview.pauseTrinityPlayer();
                }
            });
            $('#ee-editions-modal').on('show.bs.modal', function() {
                isEditionsOpen = true;
            });
            $('#ee-editions-modal').on('hide.bs.modal', function() {
                isEditionsOpen = false;
            });

            ee.cutouts.registerEvents();
            
            ////// Standard Events /////
            // On page load
            // Page View Event
            var zoom = (SCALE - zoomRange.min) * 2 / (zoomRange.max - zoomRange.min);
            __tnt.eedition.logEEditionPageViewed({
                'segmented' : d.querySelector('.ee-segment-link') ? true : false,
                'zoom_level':  Math.round(zoom * 100) / 100,
                'display_fit': container.dataset.pageSizing
            });
            // Navigation links in navbar
            d.querySelectorAll('.ee-navbar-region-pages li a').forEach(function(el) {
                el.addEventListener('click', function() {
                    // E-Edition Page Navigation Event
                   __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'navbar'});
                });
            });
            // Navigation links in pageview (next/prev buttons)
            d.querySelectorAll('#ee-pageview > a').forEach(function(el) {
                el.addEventListener('click', function() {
                    // E-Edition Page Navigation Event
                    __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'next_prev_buttons'});
                });
            });
            //Navigation in pages menu
            d.querySelectorAll('.ee-pages-grid-item').forEach(function(el) {
                el.addEventListener('click', function() {
                    // E-Edition Page Navigation Event
                    __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'pages_menu'});
                });
            });
            // Puzzles link in navbar
            if (d.querySelector('.ee-nav-item-puzzles')) {
                d.querySelector('.ee-nav-item-puzzles a').addEventListener('click', function() {
                    // E-Edition Page Navigation Event
                    __tnt.eedition.logEEditionPageNavigationInitiated({
                        'navigation_method': 'navbar',
                        'navigation_subsection': 'Puzzles'
                    });
                });
            }
            // Puzzles link in menu
            if (d.querySelector('.ee-menu-btn-puzzles')) {
                d.querySelector('.ee-menu-btn-puzzles').addEventListener('click', function() {
                    // E-Edition Page Navigation Event
                    __tnt.eedition.logEEditionPageNavigationInitiated({
                        'navigation_method': 'page_menu',
                        'navigation_subsection': 'Puzzles'
                    });
                });
            }
            // Links in search
            if (document.getElementById('search-holder')) {
                iframe = document.getElementById('search-holder'); 
                
                iframe.addEventListener('load', function () {
                    iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                    
                    iframeDoc.addEventListener('click', function(e) {
                        if (e.target.classList.contains('tnt-asset-link')) {
                            __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'search'});
                        };
                    });
                });
            }
            
            
            // Legacy GTM events
            if (window.dataLayer) {
                // Navigation links in navbar
                d.querySelectorAll('.ee-navbar-region-pages li a').forEach(function(el) {
                    el.addEventListener('click', function() {
                        dataLayer.push({'event':'tncms.event.trigger','tncms':{'event':{'trigger':{'action':'navigation','category':'e-edition','label':'main-paging'}}}});
                    });
                });
                // Navigation links in pageview
                d.querySelectorAll('#ee-pageview > a').forEach(function(el) {
                    el.addEventListener('click', function() {
                        dataLayer.push({'event':'tncms.event.trigger','tncms':{'event':{'trigger':{'action':'navigation','category':'e-edition','label':'paging'}}}});
                    });
                });
                // Puzzles link in navbar
                if (d.querySelector('.ee-nav-item-puzzles')) {
                    d.querySelector('.ee-nav-item-puzzles a').addEventListener('click', function() {
                        dataLayer.push({'event':'tncms.event.trigger','tncms':{'event':{'trigger':{'action':'navigation','category':'e-edition','label':'main-puzzles'}}}});
                    });
                }
                // Puzzles link in menu
                if (d.querySelector('.ee-menu-btn-puzzles')) {
                    d.querySelector('.ee-menu-btn-puzzles').addEventListener('click', function() {
                        dataLayer.push({'event':'tncms.event.trigger','tncms':{'event':{'trigger':{'action':'navigation','category':'e-edition','label':'menu-puzzles'}}}});
                    });
                }
            }
            
            d.getElementById('ee-menu-btn').addEventListener('click', function(e) {
                ee.menu.toggle();
            });
            
            d.getElementById('ee-menu-close-btn').addEventListener('click', function(e) {
                ee.menu.close();
            });
            
            bottomAdCloseBtn.addEventListener('click', function(e) {
                if (localStorageSupported) {
                    localStorage.setItem('tnt-ee-bottom-ad-hidden', Date.now());
                }
                bottomAd.classList.remove('ee-bottom-ad-shown');
                bottomAd.classList.add('ee-bottom-ad-hidden');
                
                ee.pageview.adjustLayout();
            });
            
            container.querySelectorAll('.ee-pages-btn').forEach(function(el) {
                el.addEventListener('click', function(e) {
                    if (e.target.closest('#ee-menu')) {
                        ee.menu.close();
                    }
                    ee.pagespane.toggle();
                });
            });
            
            container.querySelectorAll('[data-target="#ee-search-modal"]').forEach(function(el) {
                el.addEventListener('click', function() {
                    var searchHolder = d.getElementById('search-holder');
                    if (searchHolder.dataset.populated == 'false') {
                        searchHolder.src = __tnt.scrubUrl(d.getElementById('ee-search-modal').dataset.searchUrl);
                        searchHolder.dataset.populated = 'true';
                    }
                });
            });
            
            container.querySelectorAll('.ee-clip-btn').forEach(function(el) {
                el.addEventListener('click', function(e) {
                    var label;
                    if (isStoryviewOpen) {
                        ee.storyview.close();
                    }
                    if (isPagespaneOpen) {
                        ee.pagespane.close();
                    }
                    if (isMenuOpen) {
                        ee.menu.close();
                    }
                    
                    // Legacy GTM Event
                    label = (e.target.closest('#ee-menu')) ? 'menu-clip' : 'main-clip';
                    ee.tracking.report({'event':'tncms.event.trigger','tncms':{'event':{'trigger':{'action':'navigation','category':'e-edition','label':label}}}});

                    ee.clip.init();
                });
            });
            
            d.getElementById('ee-pages-menu-close-btn').addEventListener('click', function(e) {
                ee.pagespane.close();
            });
            
            if (storyview) {
                d.getElementById('ee-storyview-close-btn').addEventListener('click', function(e) {
                    ee.storyview.close();
                });
                
                d.getElementById('ee-storyview-prev-btn').addEventListener('click', function(e) {
                    ee.storyview.loadPrevious();
                });
                
                d.getElementById('ee-storyview-next-btn').addEventListener('click', function(e) {
                    ee.storyview.loadNext();
                });
            }
            
            // Replace with vanilla JS eventually
            $('#ee-print-modal').on('show.bs.modal', function (e) {
                var trigger = e.relatedTarget.dataset.trigger;
                this.querySelector('.modal-title').textContent = trigger;
            });
            $('#ee-full-edition-collapse').collapse({
                toggle: false
            });
            
            d.getElementById('print-current-page-btn').addEventListener('click', function(e) {
                ee.utilities.gtmDownloadEvent('page download', e.target.textContent.trim(), e.target.href);
            });
            
            printEditionBtn.addEventListener('click', function(e) {
                if (d.getElementById('ee-full-edition-collapse').classList.contains('in') == false) {
                    $('#ee-full-edition-collapse').collapse('show');
                    ee.utilities.download();
                    ee.utilities.gtmDownloadEvent('full download', e.target.textContent.trim(), e.target.href);
                }
            });
            
            d.getElementById('retry-print-edition-btn').addEventListener('click', function(e) {
                ee.utilities.download();
            });
            
            d.querySelector('.ee-help-btn').addEventListener('click', function() {
                ee.help.init();
            });

            // Update lastX and lastY
            pageviewContent.addEventListener('scroll', function(e) {
                if (!isPanning) {
                    lastX = pageviewContent.scrollLeft;
                    lastY = pageviewContent.scrollTop;
                }
            });

            // segments
            /* this is defined as a tap for touch devices */
            ee.hammer.on('tap pressup', function (e) {
                ee.pageview.handleClick(e);
            });
            
            ee.hammer.on('panstart', function(e) {
                if (canPan) {
                    if (imagesWrapper.clientWidth - pageviewContent.clientWidth <= Math.ceil(pageviewContent.scrollLeft)) {
                        pageviewOnRightEdge = true;
                    }
                    if (pageviewContent.scrollLeft == 0) {
                        pageviewOnLeftEdge = true;
                    }
                    panstartEl = e.target;
                    isPanning = true;
                    pageviewContent.style.cursor = 'grabbing';
                }
            });
            
            ee.hammer.on('pan', function (e) {
                if (canPan) {
                    ee.app.translate(e.deltaX, e.deltaY);
                    if (!isPanning) isPanning = true;
                }
            });
            
            ee.hammer.on('panend pancancel', function (e) {
                if (canPan) {
                    lastX = pageviewContent.scrollLeft;
                    lastY = pageviewContent.scrollTop;

                    /* Pagepeek panning logic */
                    // Left Pagepeek
                    if (
                        panstartEl?.dataset?.pagepeek == 'left'
                        && e.deltaX > 0
                        && e.distance > 10
                        && Math.atan2(Math.abs(e.deltaY), Math.abs(e.deltaX)) < 0.6 // angle is less than ~35 degrees
                    ) {
                        // E-Edition Page Navigate Event
                        __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'swipe'});
                        
                        window.location = ee.app.getPrevUrl();
                        
                    // Right pagepeek
                    } else if (
                        panstartEl?.dataset?.pagepeek == 'right'
                        && e.deltaX < 0
                        && e.distance > 10
                        && Math.atan2(Math.abs(e.deltaY), Math.abs(e.deltaX)) < 0.6 // angle is less than ~35 degrees
                    ) {
                        // E-Edition Page Navigate Event
                        __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'swipe'});
                        
                        window.location = ee.app.getNextUrl();
                    }
                    
                    /* Swiping logic */
                    // Swipe Left
                    if (
                        pageviewOnRightEdge
                        && e.velocityX < -0.3 && e.distance > 10
                        && Math.atan2(Math.abs(e.deltaY), Math.abs(e.deltaX)) < 0.6 // angle is less than ~35 degrees
                    ) {
                        // E-Edition Page Navigate Event
                        __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'swipe'});
                        
                        window.location = ee.app.getNextUrl();
                    
                    // Swipe Right
                    } else if (
                        pageviewOnLeftEdge
                        && e.velocityX > 0.3 && e.distance > 10
                        && Math.atan2(Math.abs(e.deltaY), Math.abs(e.deltaX)) < 0.6 // angle is less than ~35 degrees
                    ) {
                        // E-Edition Page Navigate Event
                        __tnt.eedition.logEEditionPageNavigationInitiated({'navigation_method': 'swipe'});
                        
                        window.location = ee.app.getPrevUrl();
                    }
                    
                    pageviewOnRightEdge = false;
                    pageviewOnLeftEdge = false;

                    panstartEl = null;
                    isPanning = false;
                    pageviewContent.style.cursor = '';
                }
            });

            ee.hammer.on('pinchstart', function(e) {
                canPan = false;
                isPanning = true;
            });
            
            ee.hammer.on('pinch', function (e) {
                // Ignore pinch events where the scale is exactly 1
                if (e.scale !== 1) {
                    if (pinchCenter === null) {
                        pinchCenter = {
                            x: e.center.x,
                            y: e.center.y - navbarHeight
                        };
                    }
                    
                    ee.app.zoomAround(e.scale, pinchCenter.x, pinchCenter.y, true);
                    lastScale = e.scale;
                }
            });
            
            ee.hammer.on('pinchend pinchcancel', function (e) {
                // Use last valid scale value if event scale is exactly 1. This fixes a strange bug in iOS during pinchcancel events.
                if (e.scale == 1) {
                    SCALE = ee.utilities.clamp(SCALE * lastScale, MIN_SCALE, MAX_SCALE);
                } else {
                    SCALE = ee.utilities.clamp(SCALE * e.scale, MIN_SCALE, MAX_SCALE);
                }
                ee.app.saveZoom();
                lastX = pageviewContent.scrollLeft;
                lastY = pageviewContent.scrollTop;
                pinchCenter = null;
                // Add a delay for allowing panning after pinch zoom to avoid jumps
                setTimeout(function() {
                    canPan = true;
                    isPanning = false;
                }, 200);
            });

            eventsRegistered = true;
        }
    };


    eedition.pageview = {
        initPageLayout: function() {
            SCALE = ee.app.getScale();
            ee.tracking.reportZoom(SCALE);
            zoomRange.value = SCALE;

            ee.pageview.layoutPages();
            ee.pageview.layoutPagepeeks();
            
            imagesWrapperProxy.style.display = 'none';
            imagesWrapper.style.display = '';
        },

        getImageSizes: function() {
            var imageSizes = [[0, 0], [0, 0]];
            if (pageDisplay == 'left' || facingPagesActive) {
                imageSizes[0] = [imageLeftRealSize[0], imageLeftRealSize[1]];
            }
            if (pageDisplay == 'right' || facingPagesActive) {
                imageSizes[1] = [imageRightRealSize[0], imageRightRealSize[1]];
            }
            return imageSizes;
        },

        layoutPages: function(_scale) {
            if (typeof _scale === 'undefined') {
                _scale = SCALE;
            }
        
            var imageSizes = ee.pageview.getImageSizes();
            
            imagesWrapper.style.height = Math.max(imageSizes[0][1] * _scale, imageSizes[1][1] * _scale) + 'px';
            imagesWrapper.style.width = (imageSizes[0][0] * _scale) + (imageSizes[1][0] * _scale) + 'px';
            imageContainerLeft.style.height = (imageSizes[0][1] * _scale) + 'px';
            imageContainerLeft.style.width = (imageSizes[0][0] * _scale) + 'px';
            if (facingPagesActive || pageDisplay == 'right') {
                imageContainerRight.style.height = (imageSizes[1][1] * _scale) + 'px';
                imageContainerRight.style.width = (imageSizes[1][0] * _scale) + 'px';
            }
        },
        
        adjustLayout: function() {
            pageviewContent.style.height = window.innerHeight - bottomAd.offsetHeight - navbar.offsetHeight + 'px';
            
            var isMinScale = (SCALE == MIN_SCALE) ? true : false;
            ee.app.getScaleBounds();
            
            SCALE = isMinScale ? MIN_SCALE : ee.utilities.clamp(SCALE, MIN_SCALE, MAX_SCALE);
            zoomRange.value = SCALE;
            ee.pageview.layoutPages();
            ee.pageview.layoutPagepeeks();
        },
        
        layoutPagepeeks: function() {
            pagepeekLeft.style.height = pageview.offsetHeight - bottomAd.offsetHeight + 'px';
            pagepeekRight.style.height = pageview.offsetHeight - bottomAd.offsetHeight + 'px';
        },
        
        asyncLoadImage: function(img) {
            var hiResUrl = img.dataset.src;
            if (hiResUrl) {
                var hiResImage = new Image();
                hiResImage.onload = function() {
                    img.src = hiResUrl;
                };
                hiResImage.src = hiResUrl;
            }
        },

        fit: function() {
            var imageSizes = ee.pageview.getImageSizes();

            SCALE = MIN_SCALE;
            ee.app.zoomCenter(SCALE);
        },

        fitToWidth: function() {
            var imageSizes = ee.pageview.getImageSizes();

            SCALE = ee.utilities.clamp((pageviewContent.offsetWidth - scrollbarWidth) / (imageSizes[0][0] + imageSizes[1][0]), MIN_SCALE, MAX_SCALE);
            ee.app.zoomAround(SCALE, pageviewContent.clientWidth / 2, 0);
        },

        fitToHeight: function() {
            var imageSizes = ee.pageview.getImageSizes();
            var heightOfTallestImage = Math.max(imageSizes[0][1], imageSizes[1][1]);

            SCALE = ee.utilities.clamp((pageviewContent.offsetHeight) / heightOfTallestImage, MIN_SCALE, MAX_SCALE);
            ee.app.zoomCenter(SCALE);
        },

        toggleFullscreen: function() {
            var fsFuncs = {
                default: {
                    fullscreenElement: 'fullscreenElement',
                    requestFullscreen: 'requestFullscreen',
                    exitFullscreen: 'exitFullscreen'
                },
                webkit: {
                    fullscreenElement: 'webkitFullscreenElement',
                    requestFullscreen: 'webkitRequestFullscreen',
                    exitFullscreen: 'webkitExitFullscreen'
                }
            };
            
            var vendor = 'default';
            if ('webkitFullscreenEnabled' in d) {
                vendor = 'webkit';
            }
            
            if (!d[fsFuncs[vendor]['fullscreenElement']]) {
                d.documentElement[fsFuncs[vendor]['requestFullscreen']]();
            } else if (d[fsFuncs[vendor]['exitFullscreen']]) {
                d[fsFuncs[vendor]['exitFullscreen']]();
            }
        },

        /* Disables event handlers on pageview images so that the browser doesn't try to automatically handle our image drag gestures */
        disableImgEventHandlers: function() {
            var events = [
                'onmousemove', 'onmouseover', 'onmouseout',
                'ondblclick', 'onfocus', 'onblur'
            ];
            var clickEvents = ['onclick', 'onmousedown', 'onmouseup'];
            var images = pageviewContent.querySelectorAll('img');
            events.forEach(function(event) {
                images.forEach(function(image) {
                    image[event] = function() {
                        return false;
                    };
                });
            });
            clickEvents.forEach(function(event) {
                images.forEach(function(image) {
                    image[event] = function(e) {
                        if (e.button === 0) {
                            return false;
                        }
                    };
                });
            });
        },

        handleClick: function(e) {
            var el = e.target;
            if (el.classList.contains('ee-segment-link') && el.tagName === 'DIV') {
                // Open cutout modal
                if (el.dataset.type === 'cutout' || el.dataset.type === 'print-ad') {
                    if (isStoryviewOpen) {
                        ee.storyview.close();
                    }
                    $('#modal-' + el.dataset.uuid).modal('show');
                    if (window.innerWidth >= 992) {
                        ee.cutouts.showMenu('modal-' + el.dataset.uuid);
                    }
                    
                // Open video modal
                } else if (el.dataset.type === 'video') {
                    $('#modal-' + el.dataset.uuid).modal('show');
                
                // Open storyview
                } else {
                    ee.storyview.removeActive();
                    el.classList.add('active');
                    ee.storyview.open();
                    ee.storyview.load(el.dataset.uuid);

                    // Give the storyview time to load so that the ads aren't the first thing the user sees
                    if (storyviewTopAd.hidden && storyviewBottomAd.hidden) {
                        setTimeout(function() {
                            storyviewTopAd.hidden = false;
                            storyviewBottomAd.hidden = false;
                        }, 150);
                    }
                }
            }
        },
        
        scrollbarAdjust: function() {
            if (ee.pageview.scrollbarWidth() > 0) {
                pagepeekRight.style.marginRight = ee.pageview.scrollbarWidth() + 'px';
                if (pageviewNextBtn) {
                    pageviewNextBtn.style.marginRight = ee.pageview.scrollbarWidth() + 'px';
                }
            } else {
                pagepeekRight.style.marginRight = '0px';
                if (pageviewNextBtn) {
                    pageviewNextBtn.style.marginRight = '0px';
                }
            }
        },

        scrollbarTimeout: null,
        
        scrollbarWidth: function() {
            return pageviewContent.offsetWidth - pageviewContent.clientWidth;
        }
        
    };


    eedition.advertising = {

        renderBloxAds: function(adEl) {
            if (__tnt && __tnt.ads && __tnt.ads.renderAd && adEl && adEl.querySelector('.blox-ad')) {
                adEl.querySelectorAll('.blox-ad').forEach(function(bloxAd) {
                    __tnt.ads.renderAd(bloxAd);
                });
            }
        }

    };


    eedition.browser = {

        isIos: function() {
            return /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        },

        isIosChrome: function() {
            return navigator.userAgent.indexOf('CriOS') > -1;
        },

        isAndroid: function() {
            return /\bAndroid\b/.test(navigator.userAgent);
        },

    };
    
    
    eedition.cutouts = {

        registerEvents: function() {
            $('.cutout-modal').on('show.bs.modal', function(e) {
                if (e.target.dataset.shown === 'true') return;
                var modal = e.target;
                var saveBtn = modal.querySelector('.cutout-save-btn');
                var canvas = modal.querySelector('canvas');
                var ctx = canvas.getContext('2d');
                var img = new Image();
                img.crossOrigin = 'anonymous';
                img.addEventListener('load', function() {
                    ctx.drawImage(img, canvas.dataset.left, canvas.dataset.top, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
                    saveBtn.href = canvas.toDataURL('image/jpeg');
                });
                
                // Load image on modal show
                img.src = canvas.dataset.imageUrl;
                modal.dataset.shown = 'true';
            });
        },
        
        toggleMenu: function(modalId) {
            var modalBody = d.getElementById(modalId).querySelector('.modal-body');
            if (modalBody.classList.contains('cutout-menu-open')) {
                ee.cutouts.hideMenu(modalId);
            } else {
                ee.cutouts.showMenu(modalId);
            }
        },
        
        showMenu: function(modalId) {
            var modal = d.getElementById(modalId);
            var modalBody = modal.querySelector('.modal-body');
            var icon = modal.querySelector('.cutout-menu-btn svg');
            modalBody.classList.add('cutout-menu-open');
            icon.classList.remove('tnt-chevron-left');
            icon.classList.add('tnt-chevron-right');
        },
        
        hideMenu: function(modalId) {
            var modal = d.getElementById(modalId);
            var modalBody = modal.querySelector('.modal-body');
            var icon = modal.querySelector('.cutout-menu-btn svg');
            modalBody.classList.remove('cutout-menu-open');
            icon.classList.remove('tnt-chevron-right');
            icon.classList.add('tnt-chevron-left');
        }
        
    };
    
    
    eedition.help = {
    
        init: function() {
            ee.help.tour.steps = [];
            ee.menu.close();

            if (isStoryviewOpen) {
                ee.storyview.pauseTrinityPlayer();
            }

            var zoomAttach, zoomText;
            if (navbarZoomSmall.offsetParent != null || navbarZoom.offsetParent != null) {
                if (navbarZoomSmall.offsetParent != null) {
                    zoomAttach = {
                        element: navbarZoomSmall,
                        on: 'bottom'
                    };
                } else if (navbarZoom.offsetParent != null) {
                    zoomAttach = {
                        element: navbarZoom,
                        on: 'bottom'
                    };
                }
                zoomText = 'Zoom in or out of the page as needed for optimal reading comfort. You can also use a pinch gesture to zoom on touch devices.';
            } else {
                zoomAttach = null;
                zoomText = 'Use a pinch gesture to zoom in or out of the page as needed for optimal reading comfort.';
            }
            ee.help.tour.addStep({
                id: 'navbar-zoom',
                title: 'Zoom',
                text: zoomText,
                attachTo: zoomAttach,
                buttons: [{
                    text: 'Next',
                    action: ee.help.tour.next
                }]
            });
            
            ee.help.tour.addStep({
                id: 'navbar-next-prev',
                title: 'Page to page navigation',
                text: 'Use these arrows to go to the next or previous page. You can also use the arrows on the left and right of the screen, or swipe left and right on touch devices.',
                attachTo: {
                    element: navbarRegionPages,
                    on: 'bottom'
                },
                buttons: [{
                    text: 'Back',
                    action: ee.help.tour.back
                },{
                    text: 'Next',
                    action: ee.help.tour.next
                }]
            });
            if (navbarRegionPages.offsetParent == null) {
                ee.help.tour.getById('navbar-next-prev').updateStepOptions({
                    text: 'Use the arrows on the left and right of the screen to go to the next or previous page. You can also swipe left and right on touch devices.',
                    attachTo: {}
                });
            }
            
            
            ee.help.tour.addStep({
                id: 'navbar-pages',
                title: 'Pages',
                text: 'The pages button has moved into the navigation menu. Use it to jump to a specific page.',
                attachTo: {
                    element: '#ee-pages-btn',
                    on: 'bottom'
                },
                buttons: [{
                    text: 'Back',
                    action: ee.help.tour.back
                },{
                    text: 'Next',
                    action: ee.help.tour.next
                }]
            });
            
            if (navItemPuzzle !== null) {
                ee.help.tour.addStep({
                    id: 'navbar-puzzles',
                    title: 'Puzzles',
                    text: 'The puzzles button takes you straight to the puzzles.',
                    attachTo: {
                        element: navItemPuzzle,
                        on: 'bottom'
                    },
                    buttons: [{
                        text: 'Back',
                        action: ee.help.tour.back
                    },{
                        text: 'Next',
                        action: ee.help.tour.next
                    }]
                });
            }
            
            var editionsAttach;
            // If navbar item is visible
            if (navItemEditions) {
                if (navItemEditions.offsetParent != null) {
                    editionsAttach = {
                        element: navItemEditions,
                        on: 'bottom'
                    };
                } else {
                    editionsAttach = {
                        element: menuBtnEditions,
                        on: 'bottom'
                    };
                }
                ee.help.tour.addStep({
                    id: 'navbar-editions',
                    title: 'Editions',
                    text: 'Access the most recent editions of this publication.',
                    attachTo: editionsAttach,
                    buttons: [{
                        text: 'Back',
                        action: ee.help.tour.back
                    },{
                        text: 'Next',
                        action: ee.help.tour.next
                    }],
                    beforeShowPromise: function() {
                        return new Promise(function(resolve) {
                            // If navbar item is visible
                            if (navItemEditions.offsetParent != null) {
                                resolve();
                            } else {
                                ee.menu.open();
                                menu.querySelector('.ee-menu-items').scrollTo(0, menuBtnEditions.offsetTop - menu.querySelector('.ee-menu-items').offsetTop);
                                setTimeout(function() {
                                    resolve();
                                }, 250); // Delay is equal to CSS transition time
                            }
                        });
                    }
                });
            }
            
            var printAttach;
            // If navbar item is visible
            if (navItemPrint.offsetParent != null) {
                printAttach = {
                    element: navItemPrint,
                    on: 'bottom'
                };
            } else {
                printAttach = {
                    element: menuBtnPrint,
                    on: 'bottom'
                };
            }
            ee.help.tour.addStep({
                id: 'navbar-print',
                title: 'Print',
                text: 'Print the current page or the entire edition for offline reading. (Requires an app that can open and print PDF files.)',
                attachTo: printAttach,
                buttons: [{
                    text: 'Back',
                    action: ee.help.tour.back
                },{
                    text: 'Next',
                    action: ee.help.tour.next
                }],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                        // If navbar item is visible
                        if (navItemPrint.offsetParent != null) {
                            resolve();
                        } else {
                            ee.menu.open();
                            menu.querySelector('.ee-menu-items').scrollTo(0, menuBtnPrint.offsetTop - menu.querySelector('.ee-menu-items').offsetTop);
                            setTimeout(function() {
                                resolve();
                            }, 250); // Delay is equal to CSS transition time
                        }
                    });
                }
            });
            
            var downloadAttach;
            // If navbar item is visible
            if (navItemDownload.offsetParent != null) {
                downloadAttach = {
                    element: navItemDownload,
                    on: 'bottom'
                };
            } else {
                downloadAttach = {
                    element: menuBtnDownload,
                    on: 'bottom'
                };
            }
            ee.help.tour.addStep({
                id: 'navbar-download',
                title: 'Download',
                text: 'Download the current page or the entire edition for offline reading. (Requires an app that can open and view PDF files.)',
                attachTo: downloadAttach,
                classes: 'example-step-extra-class',
                buttons: [{
                    text: 'Back',
                    action: ee.help.tour.back
                },{
                    text: 'Finish',
                    action: ee.help.tour.complete
                }],
                beforeShowPromise: function() {
                    return new Promise(function(resolve) {
                        // If navbar item is visible
                        if (navItemDownload.offsetParent != null) {
                            resolve();
                        } else {
                            ee.menu.open();
                            menu.querySelector('.ee-menu-items').scrollTo(0, menuBtnDownload.offsetTop - menu.querySelector('.ee-menu-items').offsetTop);
                            setTimeout(function() {
                                resolve();
                            }, 250); // Delay is equal to CSS transition time
                        }
                    });
                }
            });
            
            ee.help.tour.start();
        },
        
        handleResize: function() {
            // Loop through all steps and customize them if needed
            ee.help.tour.steps.forEach(function(step) {
                if (step.id == 'navbar-zoom') {
                    var zoomAttach, zoomText;
                    if (navbarZoomSmall.offsetParent != null || navbarZoom.offsetParent != null) {
                        if (navbarZoomSmall.offsetParent != null) {
                            zoomAttach = {
                                element: navbarZoomSmall,
                                on: 'bottom'
                            };
                        } else if (navbarZoom.offsetParent != null) {
                            zoomAttach = {
                                element: navbarZoom,
                                on: 'bottom'
                            };
                        }
                        zoomText = 'Zoom in or out of the page as needed for optimal reading comfort. You can also use a pinch gesture to zoom on touch devices.';
                    } else {
                        zoomAttach = null;
                        zoomText = 'Use a pinch gesture to zoom in or out of the page as needed for optimal reading comfort.';
                    }
                    step.updateStepOptions({
                        attachTo: zoomAttach,
                        text: zoomText
                    });
                    
                } else if (step.id == 'navbar-next-prev') {
                    if (navbarRegionPages.offsetParent != null) {
                        step.updateStepOptions({
                            text: 'Use these arrows to go to the next or previous page. You can also use the arrows on the left and right of the screen, or swipe left and right on touch devices.',
                            attachTo: {
                                element: navbarRegionPages,
                                on: 'bottom'
                            }
                        });
                    } else {
                        step.updateStepOptions({
                            text: 'Use the arrows on the left and right of the screen to go to the next or previous page. You can also swipe left and right on touch devices.',
                            attachTo: null
                        });
                    }
                    
                } else if (step.id == 'navbar-editions') {
                    var editionsAttach;
                    // If navbar item is visible
                    if (navItemEditions.offsetParent != null) {
                        editionsAttach = {
                            element: navItemEditions,
                            on: 'bottom'
                        };
                    } else {
                        editionsAttach = {
                            element: menuBtnEditions,
                            on: 'bottom'
                        };
                    }
                    step.updateStepOptions({
                        attachTo: editionsAttach
                    });
                    
                } else if (step.id == 'navbar-print') {
                    var printAttach;
                    // If navbar item is visible
                    if (navItemPrint.offsetParent != null) {
                        printAttach = {
                            element: navItemPrint,
                            on: 'bottom'
                        };
                    } else {
                        printAttach = {
                            element: menuBtnPrint,
                            on: 'bottom'
                        };
                    }
                    step.updateStepOptions({
                        attachTo: printAttach
                    });
                    
                } else if (step.id == 'navbar-download') {
                    var downloadAttach;
                    // If navbar item is visible
                    if (navItemDownload.offsetParent != null) {
                        downloadAttach = {
                            element: navItemDownload,
                            on: 'bottom'
                        };
                    } else {
                        downloadAttach = {
                            element: menuBtnDownload,
                            on: 'bottom'
                        };
                    }
                    step.updateStepOptions({
                        attachTo: downloadAttach
                    });
                }
            });
            
            ee.help.tour.getCurrentStep().show();
        },
        
        timeout: false,
        
        debounce: function() {
            clearTimeout(ee.help.timeout);
            ee.help.timeout = setTimeout(ee.help.handleResize, 250); // Delay is equal to CSS transition time
        },
        
        tour: new Shepherd.Tour({
            useModalOverlay: true,
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true,
                    label: 'Close'
                },
                scrollTo: false,
                popperOptions: {
                    modifiers: [{ name:'offset', options:{ offset:[0,10] } }]
                }
            }
        })
    
    };
    
    
    eedition.menu = {
    
        open: function() {
            menu.removeEventListener('transitionend', ee.menu.onTransitionEnd);
            menu.style.visibility = 'visible';
            menu.classList.add('open');
            isMenuOpen = true;

            if (isStoryviewOpen) {
                ee.storyview.pauseTrinityPlayer();
            }
        },
        
        close: function() {
            menu.addEventListener('transitionend', ee.menu.onTransitionEnd);
            menu.classList.remove('open');
            isMenuOpen = false;
        },
        
        onTransitionEnd: function(e) {
            if (e.target.id == 'ee-menu') {
                menu.style.visibility = 'hidden';
                menu.removeEventListener('transitionend', ee.menu.onTransitionEnd);
            }
        },
        
        toggle: function() {
            if (isMenuOpen === false) {
                ee.menu.open();
            } else {
                ee.menu.close();
            }
        }
    
    };
    
    
    eedition.navbar = {
        
        enableZoom: function() {
            d.querySelectorAll('.ee-zoom-out').forEach(function(el) {
                el.disabled = false;
            });
            d.querySelectorAll('.ee-zoom-in').forEach(function(el) {
                el.disabled = false;
            });
            d.getElementById('ee-zoom-range').disabled = false;
        },
        
        disableZoom: function() {
            d.querySelectorAll('.ee-zoom-out').forEach(function(el) {
                el.disabled = true;
            });
            d.querySelectorAll('.ee-zoom-in').forEach(function(el) {
                el.disabled = true;
            });
            d.getElementById('ee-zoom-range').disabled = true;
        },

        enableDisplay: function() {
            d.getElementById('ee-display-btn').disabled = false;
        },
        
        disableDisplay: function() {
            d.getElementById('ee-display-btn').disabled = true;
        }
        
    };
    
    
    eedition.pagepeeks = {
    
        visible: false,
        showThrottled: false,
        
        canFit: function() {
            var padding = 50;
            if (pageviewContent.clientWidth - imagesWrapper.offsetWidth - padding >= 320 + 320) {
                return true;
            }
            return false;
        },
        
        check: function(throttleShow) {
            if (ee.pagepeeks.visible) {
                if (!ee.pagepeeks.canFit()) {
                    ee.pagepeeks.hide();
                }
            } else {
                var showFn = function() {
                    if (ee.pagepeeks.canFit()) {
                        ee.pagepeeks.show();
                    }
                };
                if (throttleShow) {
                    if (!ee.pagepeeks.showThrottled) {
                        ee.pagepeeks.showThrottled = true;
                        setTimeout(function() {
                            showFn();
                            ee.pagepeeks.showThrottled = false;
                        }, 250); // Delay is equal to CSS transition time
                    }
                } else {
                    showFn();
                }
            }
        },
        
        onTransitionEnd: function(e) {
            if (e.target.id == 'ee-pagepeek-left' && e.propertyName == 'opacity') {
                pagepeekLeft.style.display = 'none';
                pagepeekLeft.removeEventListener('transitionend', ee.pagepeeks.onTransitionEnd);
            } else if (e.target.id == 'ee-pagepeek-right' && e.propertyName == 'opacity') {
                pagepeekRight.style.display = 'none';
                pagepeekRight.removeEventListener('transitionend', ee.pagepeeks.onTransitionEnd);
            }
        },
        
        hide: function() {
            pagepeekLeft.addEventListener('transitionend', ee.pagepeeks.onTransitionEnd);
            pagepeekRight.addEventListener('transitionend', ee.pagepeeks.onTransitionEnd);
            pagepeekLeft.classList.add('ee-pagepeek-fade');
            pagepeekRight.classList.add('ee-pagepeek-fade');
            ee.pagepeeks.visible = false;
        },
        
        show: function() {
            // Remove transitionend event in case we interupt the transition
            pagepeekLeft.removeEventListener('transitionend', ee.pagepeeks.onTransitionEnd);
            pagepeekRight.removeEventListener('transitionend', ee.pagepeeks.onTransitionEnd);

            pagepeekLeft.style.display = '';
            pagepeekRight.style.display = '';
            setTimeout(function() {
                pagepeekLeft.classList.remove('ee-pagepeek-fade');
                pagepeekRight.classList.remove('ee-pagepeek-fade');
            }, 10);
            ee.pagepeeks.visible = true;
        },

    };
    
    
    eedition.pagespane = {
        
        open: function() {
            if (isMenuOpen) {
                ee.menu.close();
            }
            if (isStoryviewOpen) {
                ee.storyview.close();
            }
            
            pagesMenu.style.visibility = 'visible';
            pagesMenu.classList.add('open');
            isPagespaneOpen = true;
        },
        
        close: function() {
            pagesMenu.classList.remove('open');
            pagesMenu.addEventListener('transitionend', ee.pagespane.onTransitionEnd);
            isPagespaneOpen = false;
        },
        
        onTransitionEnd: function(e) {
            if (e.target.id == 'ee-pages-pane') {
                pagesMenu.style.visibility = 'hidden';
                pagesMenu.removeEventListener('transitionend', ee.pagespane.onTransitionEnd);
            }
        },
        
        toggle: function() {
            if (isPagespaneOpen === false) {
                ee.pagespane.open();
            } else {
                ee.pagespane.close();
            }
        }
    }
    
    
    eedition.storyview = {
    
        init: function() {
            ee.storyview.observer = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.intersectionRatio == 0) {
                        d.getElementById('ee-storyview-headline').style.opacity = 1;
                    } else {
                        d.getElementById('ee-storyview-headline').style.opacity = 0;
                    }
                });
            }, {
                root: storyviewContent,
                threshold: 0
            });
            
            // hide next/prev if only one segment
            if (d.querySelector('.ee-story-templates') && d.querySelector('.ee-story-templates').childElementCount == 1) {
                storyview.classList.add('one-segment');
            }
        },
    
        open: function() {
            if (isStoryviewOpen) return;

            if (isMenuOpen) {
                ee.menu.close();
            }
            if (isPagespaneOpen) {
                ee.pagespane.close();
            }
            
            storyview.removeEventListener('transitionend', ee.storyview.onTransitionEnd);
            storyview.addEventListener('transitionend', ee.storyview.onTransitionEnd);

            storyview.style.visibility = 'visible';
            ee.pagepeeks.hide();
        
            viewport.classList.add('storyview-open');
            isStoryviewOpen = true;
        },
        
        onTransitionEnd: function(e) {
            if (e.target.id == 'ee-storyview') {
                // On open
                if (isStoryviewOpen) {
                    ee.advertising.renderBloxAds(storyviewTopAd);
                    ee.advertising.renderBloxAds(storyviewBottomAd);

                // On close
                } else {
                    ee.pagepeeks.check();
                    storyview.style.visibility = 'hidden';
                }
                storyview.removeEventListener('transitionend', ee.storyview.onTransitionEnd);
            }
        },
        
        close: function() {
            if (!isStoryviewOpen) return;

            viewport.classList.remove('storyview-open');
            // Pause all videos
            storyview.querySelectorAll('video').forEach(function(el) {
                el.pause();
            });

            ee.storyview.pauseTrinityPlayer();

            storyview.addEventListener('transitionend', ee.storyview.onTransitionEnd);
            
            // Remove all existing active links
            ee.storyview.removeActive();
            
            isStoryviewOpen = false;
        },
        
        load: function(uuid) {
            // Unload logic
            if (segment.firstElementChild) {
                // Don't do anything if the asset is already loaded
                if (segment.firstElementChild.dataset.uuid == uuid) {
                    return;
                }
                
                // Pause all videos
                storyview.querySelectorAll('video').forEach(function(el) {
                    el.pause();
                });

                // Remove Trinity Audio player
                if (window.TRINITY_PLAYER) {
                    var trinityId = 'asset-content-player-' + segment.firstElementChild.dataset.uuid;
                    TRINITY_PLAYER.api.removePlayer(trinityId);
                }

                // Unobserve the h1
                if (segment.querySelector('h1')) {
                    ee.storyview.observer.unobserve(segment.querySelector('h1'));
                }
                // Wipe out headline content
                d.getElementById('ee-storyview-headline').textContent = '';
            }
            
            var templateEl = d.getElementById('segment-'+uuid);
            
            // Standard Events
             __tnt.eedition.logEEditionSegmentAssetView({
                 'segment_asset_id': uuid,
                 'segment_asset_url': templateEl.dataset.absUrl,
                 'segment_asset_name': templateEl.dataset.title,
                 'segment_asset_page_number': container.dataset.pageRefNum
             });
            
            // Legacy Events
            if (window.dataLayer) {
                // virtual pageview
                var storyUrl = templateEl.dataset.url.replace(/^.*\/\/[^\/]+/, '');
                dataLayer.push({
                    'event': 'tncms.event.virtual_pageview',
                        'tncms.event.virtual_pageview.url': storyUrl,
                        'tncms.event.virtual_pageview.title': templateEl.dataset.title,
                        'tncms.event.virtual_pageview.metric': 'eedition_page_navigation'
                });
                
                // eedition asset view
                var eeUrl = w.location.href.replace(/^.*\/\/[^\/]+/, '');
                dataLayer.push({
                    'event': 'tncms.event.eedition_asset_view',
                        'tncms.event.eedition_asset_view.url': storyUrl,
                        'tncms.event.eedition_asset_view.title': templateEl.dataset.title,
                        'tncms.event.eedition_asset_view.edition_url': eeUrl,
                        'tncms.event.eedition_asset_view.eedition_page': container.dataset.pageNum
                });
            }
            
            // Field59 specific logic so we can reload videos
            /* Commented out to get working at a later date
            if (typeof field59 != 'undefined' && typeof field59.players != 'undefined') {
                field59.players = [];
            }
            */
            
            var df = d.createDocumentFragment();
            var clone = templateContent(templateEl).cloneNode(true);
            
            // Fix preview URLs
            if (window.location.pathname.indexOf('/tncms/admin/action/main/preview/site') != -1) {
                clone.querySelectorAll('a').forEach(function(el) {
                    // check if URL starts with '/' (ie11 compatible)
                    if (el.href && el.getAttribute('href').lastIndexOf('/', 0) === 0) {
                        el.href = __tnt.scrubUrl(el.href);
                    }
                });
            }
            
            var html = d.importNode(clone, true);
            df.appendChild(html);
            
            // Check localStorage for textsize and set it
            var textSize;
            if (localStorageSupported && localStorage.getItem('tnt-eedition-textsize')) {
                textSize = localStorage.getItem('tnt-eedition-textsize');
            }

            // Timeout so that Field59 can register items as visible
            setTimeout(function() {
                if (segment.firstElementChild) {
                    segment.removeChild(segment.firstElementChild);
                }
                segment.appendChild(df);
                if (textSize) {
                    var segArticle = segment.querySelector('article');
                    segArticle.classList.remove('text-md', 'text-lg');
                    segArticle.classList.add('text-'+textSize);
                }
                storyviewContent.scrollTop = 0;
                
                if (segment.querySelector('h1')) {
                    ee.storyview.observer.observe(segment.querySelector('h1'));
                    d.getElementById('ee-storyview-headline').textContent = segment.querySelector('h1').textContent;
                }

                // Recreate Trinity Audio player
                if (window.TRINITY_PLAYER) {
                    var trinityId = 'asset-content-player-' + segment.firstElementChild.dataset.uuid;
                    if (segment.querySelector('[data-player-id="'+ trinityId +'"]')) {
                        TRINITY_PLAYER.api.createPlayer(trinityId);
                    }
                }
            }, 100);
        },
        
        loadNext: function() {
            var segmentCount = storyview.querySelector('.ee-story-templates').childElementCount;
            // don't do anything if only one segment
            if (segmentCount === 1) {
                return;
            }
            
            var nextTemplate = ee.storyview.getNextPrevTemplate(1);
            
            // Remove active links and set first segment region to active
            ee.storyview.removeActive();
            imagesWrapper.querySelector('[data-uuid="'+nextTemplate.dataset.uuid+'"]').classList.add('active');
            
            ee.storyview.load(nextTemplate.dataset.uuid);
        },
        
        loadPrevious: function() {
            var segmentCount = storyview.querySelector('.ee-story-templates').childElementCount;
            // don't do anything if only one segment
            if (segmentCount === 1) {
                return;
            }

            var prevTemplate = ee.storyview.getNextPrevTemplate(-1);

            // Remove active links and set first segment region to active
            ee.storyview.removeActive();
            imagesWrapper.querySelector('[data-uuid="'+prevTemplate.dataset.uuid+'"]').classList.add('active');
            
            ee.storyview.load(prevTemplate.dataset.uuid);
        },
        
        getNextPrevTemplate: function(step) {
            step = typeof step !== 'undefined' ? step : 1;
            var validTemplates, currentTemplate, currentIndex, navIndex;
            if (pageDisplay == 'both') {
                validTemplates = Array.from(storyview.querySelectorAll('.ee-story-templates template'));
            } else {
                validTemplates = Array.from(storyview.querySelectorAll('.ee-story-templates template[data-page="' + pageDisplay + '"]'));
            }
            currentTemplate = storyview.querySelector('.ee-story-templates [data-uuid="'+segment.firstElementChild.dataset.uuid+'"]');
            currentIndex = validTemplates.indexOf(currentTemplate);
            navIndex = mod(currentIndex + step, validTemplates.length);
            return validTemplates[navIndex];
        },

        pauseTrinityPlayer: function() {
            if (window.TRINITY_PLAYER) {
                var trinityId = 'asset-content-player-' + segment.firstElementChild.dataset.uuid;
                if (TRINITY_PLAYER.players[trinityId]) {
                    TRINITY_PLAYER.api.pause(trinityId);
                }
            }
        },

        removeActive: function() {
            imagesWrapper.querySelectorAll('.ee-segment-link.active').forEach(function(el) {
                el.classList.remove('active');
            });
        }
    };
    
    
    eedition.subscription = {
    
        downloads: function(display, type) {
            if (display == 'show') {
                navbar.querySelector('.ee-nav-item-print').classList.remove('hide');
                navbar.querySelector('.ee-nav-item-download').classList.remove('hide');
                menu.querySelector('.ee-menu-btn-print').parentElement.classList.remove('hide');
                menu.querySelector('.ee-menu-btn-download').parentElement.classList.remove('hide');
                d.getElementById('ee-print-panel').querySelectorAll('.panel')[1].classList.remove('hide');
            } else if (display == 'hide') {
                if (type == 'full edition') {
                    d.getElementById('ee-print-panel').querySelectorAll('.panel')[1].classList.add('hide');
                } else {
                    navbar.querySelector('.ee-nav-item-print').classList.add('hide');
                    navbar.querySelector('.ee-nav-item-download').classList.add('hide');
                    menu.querySelector('.ee-menu-btn-print').parentElement.classList.add('hide');
                    menu.querySelector('.ee-menu-btn-download').parentElement.classList.add('hide');
                }
            }
        },
        
        hasPremiumSection: function() {
            if (container.dataset.hasPremiumSection && container.dataset.hasPremiumSection === 'true') {
                return true;
            }
            return false;
        },
        
        hasServices: function() {
            if (pageviewContent.classList.contains('subscriber-only')) {
                return true;
            }
            return false;
        },
        
        isSuperUser: function() {
            var superUser = false;

            if (__tnt.user.services) {
                var bloxUserServiceIDs = __tnt.user.services.replace('%2C',',').split(',');
                bloxUserServiceIDs.forEach(function(value) {
                    if (value == 0) superUser = true;
                });
            }
            return superUser;
        },
        
        modal: function(func) {
            if (func == 'load') {
                if (d.querySelector('.tiered-access-modal') === null) {
                    var template = d.getElementById('tiered-access');
                    var modal = d.createElement('div');
                    modal.innerHTML = '' +
                        '<div class="modal-dialog" role="document">' + 
                            '<div class="modal-content">' +
                                '<div class="modal-body"></div>' +
                            '</div>' +
                        '</div>';
                    modal.classList.add('modal', 'fade', 'tiered-access-modal');
                    modal.tabindex = '-1';
                    modal.role = 'dialog';
                    modal.setAttribute('aria-label', 'Tiered Access');
                    
                    modal.querySelector('.modal-body').appendChild(templateContent(template));
                    pageview.appendChild(modal);
                }

                $(modal).modal({
                    'backdrop': 'static',
                    'keyboard': false,
                    'show': true
                });

                pageview.classList.add('tiered-access');
                ee.navbar.disableZoom();
                // Disable clipping tool
                container.querySelectorAll('.ee-clip-btn').forEach(function(el) {
                    el.disabled = true;
                });

            } else if (func == 'hide') {
                if (d.querySelector('.tiered-access-modal') !== null) {
                    if (pageview.classList.contains('tiered-access')) {
                        $('.tiered-access-modal').modal('hide');
                        pageview.classList.remove('tiered-access');
                        ee.navbar.enableZoom();
                        // Enable clipping tool
                        container.querySelectorAll('.ee-clip-btn').forEach(function(el) {
                            el.disabled = false;
                        });
                    }
                }
            }
        },
        
        tieredAccess: function() {
            if (container.dataset.isPremiumSection === 'true') {
                if (Cookies.get('leefalcon_membership') != 'PLAT' && !this.isSuperUser()) {
                    this.modal('load');
                    if (container.dataset.pdfRestriction === 'true') {
                        this.downloads('hide', null);
                    }
                    return true;
                }
            } else {
                this.modal('hide');
                if (this.hasPremiumSection() && Cookies.get('leefalcon_membership') != 'PLAT' && container.dataset.pdfRestriction === 'true') {
                    this.downloads('hide', 'full edition');
                }
            }
        }
        
    };


    eedition.tracking = {
    
        report: function(data) {
            if (window.dataLayer && data) {
                dataLayer.push(data);
            }
        },
        
        reportSegmented: function() {
            var isSegmented = false;
            if (storyview) {
                isSegmented = (pageDisplay == 'both')
                    ? storyview.querySelector('.ee-story-templates template') != null
                    : storyview.querySelector('.ee-story-templates template[data-page="'+pageDisplay+'"]') != null;
            }
            ee.tracking.report({'tncms.eedition.is_segmented': isSegmented});
        },
        
        reportZoom: function(_scale) {        
            // Legacy GTM event
            var zoomLevel = (Math.round(_scale * 4) / 4).toFixed(2);
            ee.tracking.report({'tncms.eedition.zoom': zoomLevel});
        }
        
    };
    ee.tracking.reportZoomDebounced = debounce(ee.tracking.reportZoom, 2500);
    
    var debouncedLogZoom = debounce(function() {
        // Standard Event
        var zoomLevel = (SCALE - zoomRange.min) * 2 / (zoomRange.max - zoomRange.min);
        __tnt.eedition.logEEditionZoomLevelModified({
            'zoom_method': zoomMethod,
            'zoom_level': Math.round(zoomLevel * 100) / 100
        });
    }, 2500);
    
    eedition.utilities = {

        clamp: function(num, min, max) {
            return Math.min(Math.max(num, min), max);
        },
        
        detectIE: function() {
            if (w.navigator.userAgent.match(/Trident.*rv:11\./)) {
                container.classList.add('ie11');
            }
        },
        
        detectMaxTouchPoints: function() {
            if (navigator.maxTouchPoints > 1) {
                navbar.classList.add('multitouch');
            } else {
                navbar.classList.add('not-multitouch');
            }
        },
        
        download: function() {
            var attempts = 0;
            var attemptDelay = 500;
            var progress = 0;
            var mergedUrl = printEditionBtn.dataset.downloadUrl;
            
            var panel = d.getElementById('ee-print-panel');
            var collapse = d.getElementById('ee-full-edition-collapse');
            var progressBar = collapse.querySelector('.progress-bar');
            var statusPrep = collapse.querySelector('.status-prep');
            var statusError = collapse.querySelector('.status-error');
            var statusSuccess = collapse.querySelector('.status-success');
            
            function updateProgress(percent) {
                progressBar.style.width = percent + '%';
                progressBar.setAttribute('aria-valuenow', percent);
                progressBar.querySelector('.sr-only').textContent = percent + '% Complete';
            }
            
            function showPrep() {
                statusSuccess.style.display = 'none';
                statusError.style.display = 'none';
                statusPrep.style.display = 'block';
            }
            
            function showError() {
                statusPrep.style.display = 'none';
                statusSuccess.style.display = 'none';
                statusError.style.display = 'block';
                updateProgress(0);
            }
            
            function getPdf(url) {
                fetch(url).then(function(response) {
                    if (response.status !== 200) {
                        console.log('There was a problem with the download. Status Code: ' + response.status);
                        showError();
                        
                    } else {
                        response.json().then(function(data) {
                            if (data.status === 'complete') {
                                updateProgress(100);
                                
                                setTimeout(function() {
                                    window.open(data.file, '_blank');
                                    setTimeout(function() {
                                        statusPrep.style.display = 'none';
                                        statusError.style.display = 'none';
                                        statusSuccess.style.display = 'block';
                                        d.getElementById('view-full-edition-btn').href = data.file;
                                    }, 500);
                                }, 1000);
                                
                            } else if (data.status === 'running') {
                                progress += 3;
                                updateProgress(progress);
                                
                                if (attempts >= 20) {
                                    showError();
                                } else {
                                    attempts++;
                                    attemptDelay += 500;
                                    setTimeout(function() {
                                        getPdf(url);
                                    }, attemptDelay);
                                }
                            }
                        });
                    }
                }).catch(function(e) {
                    console.log(e);
                    showError();
                });
            }
            
            showPrep();
            updateProgress(0);
            getPdf(mergedUrl);
        },
        
        gtmDownloadEvent: function(label, link_text, link_url) {
            window.dispatchEvent(new CustomEvent('BLOXFileDownload', {
                detail: {
                    action: 'pdfDownload',
                    category: 'e-edition',
                    label: label,
                    link_text: link_text,
                    link_url: link_url
                }
            }));
        },

        getScrollbarWidth: function() {
            var el = d.createElement('div');
            el.style.visibility = 'hidden';
            el.style.overflow = 'scroll';
            d.body.appendChild(el);
            
            var scrollbarWidth = el.offsetWidth - el.clientWidth;
            el.parentNode.removeChild(el);
            
            return scrollbarWidth;
        },

        hideItemsNowapp: function() {
            if (container.dataset.nowappMode === 'true') {
                document.querySelectorAll('.ee-nav-item-clip, .ee-menu-item-clip').forEach(function(el) {
                    el.style.display = 'none';
                });
                if (ee.browser.isAndroid()) {
                    document.querySelectorAll('.ee-nav-item-print, .ee-nav-item-download, .ee-menu-item-print, .ee-menu-item-download').forEach(function(el) {
                        el.style.display = 'none';
                    });
                }
            }
        },

        hideFullscreenIos: function() {
            if (ee.browser.isIos()) {
                d.getElementById('ee-display-fullscreen-btn').style.display = 'none';
            }
        },
        
    };
    
    d.addEventListener('DOMContentLoaded', function() {
        __tnt.eedition.app._init();
    }, false);

    d.addEventListener('GrantNowappAccess', function() {
        ee.pageview.initPageLayout();
        ee.pageview.scrollbarAdjust();
        ee.pagepeeks.check();
    });
    
})(window, document, __tnt);